// extracted by mini-css-extract-plugin
module.exports = {"button":"_9330de7794--button--urT0_","prev":"_9330de7794--prev--ZhZr4","next":"_9330de7794--next--NDAfl","carousel":"_9330de7794--carousel--_04VM"};